var exports = {
  "U": "xdde3148b--788f19--builder-reviews",
};

module.exports = exports;
